import { useState, ReactNode } from 'react'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Box, IconButton, Stack } from '@mui/material'

interface Props {
  /** Optional text shown in the divider (e.g. section label). */
  text?: ReactNode
  defaultExpanded?: boolean
  children: ReactNode
  'data-cy'?: string
}

const CollapsibleVerticalDivider = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  text,
  defaultExpanded = false,
  children,
  'data-cy': dataCy,
}: Props) => {
  const [expanded, setExpanded] = useState(defaultExpanded)

  return (
    <Stack
      direction="row"
      spacing={0}
      data-cy={dataCy}
      justifyContent={'space-evenly'}
      alignItems="center"
    >
      <IconButton
        size="small"
        onClick={() => setExpanded(prev => !prev)}
        aria-expanded={expanded}
        sx={{ paddingX: 0, paddingY: 0 }}
      >
        {expanded ? <ChevronRightIcon /> : <ChevronLeftIcon />}
      </IconButton>
      <Box sx={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0 }}>
        {expanded && children}
      </Box>
    </Stack>
  )
}

export default CollapsibleVerticalDivider
